import { createPortal } from 'react-dom'
import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { HIDE_CANVAS_DIALOG, SHOW_CANVAS_DIALOG } from '../../store/actions'
import DarkCodeEditor from '../editor/DarkCodeEditor'
import LightCodeEditor from '../editor/LightCodeEditor'

import './ExpandTextDialog.css'
import { RootState } from '@/store'

const ExpandTextDialog = ({ show, dialogProps, onCancel, onConfirm }) => {
    const portalElement: any = document.getElementById('portal')


    const dispatch = useDispatch()
    const customization = useSelector((state: RootState) => state.customization)
    const languageType = 'json'

    const [inputValue, setInputValue] = useState<any>('')
    const [inputParam, setInputParam] = useState<any>(null)

    useEffect(() => {
        if (dialogProps.value) setInputValue(dialogProps.value)
        if (dialogProps.inputParam) setInputParam(dialogProps.inputParam)

        return () => {
            setInputValue('')
            setInputParam(null)
        }
    }, [dialogProps])

    useEffect(() => {
        if (show) {
            dispatch({ type: SHOW_CANVAS_DIALOG });
        } else {
            dispatch({ type: HIDE_CANVAS_DIALOG });
        }
    
        // Cleanup function that hides the dialog when the component unmounts.
        return () => {
            dispatch({ type: HIDE_CANVAS_DIALOG });
        };
    }, [show, dispatch]);
    

    const component = show ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
            <div className={`bg-white rounded-lg shadow-lg w-full md:w-4/5 lg:w-3/5 ${customization.isDarkMode ? 'text-white' : 'text-black'}`}>
                <div className="p-4 border-b border-gray-200">
                    {inputParam && inputParam.type === 'string' && (
                        <div className="flex flex-col">
                            <h4 className="text-2xl font-semibold mb-2">{inputParam.label}</h4>
                            <PerfectScrollbar className="border border-gray-300 rounded-lg bg-white" style={{ maxHeight: 'calc(100vh - 220px)' }}>
                                {customization.isDarkMode ? (
                                    <DarkCodeEditor
                                        disabled={dialogProps.disabled}
                                        value={inputValue}
                                        onValueChange={(code) => setInputValue(code)}
                                        placeholder={inputParam.placeholder}
                                        type={languageType}
                                        style={{ fontSize: '0.875rem', minHeight: 'calc(100vh - 220px)', width: '100%' }}
                                    />
                                ) : (
                                    <LightCodeEditor
                                        disabled={dialogProps.disabled}
                                        value={inputValue}
                                        onValueChange={(code) => setInputValue(code)}
                                        placeholder={inputParam.placeholder}
                                        type={languageType}
                                        style={{ fontSize: '0.875rem', minHeight: 'calc(100vh - 220px)', width: '100%' }}
                                    />
                                )}
                            </PerfectScrollbar>
                        </div>
                    )}
                </div>
                <div className="flex justify-end p-4 border-t border-gray-200">
                    <button
                        className="bg-gray-300 text-gray-800 py-2 px-4 rounded-md mr-2"
                        onClick={onCancel}
                    >
                        {dialogProps.cancelButtonName}
                    </button>
                    <button
                        className="bg-blue-500 text-white py-2 px-4 rounded-md"
                        disabled={dialogProps.disabled}
                        onClick={() => onConfirm(inputValue, inputParam.name)}
                    >
                        {dialogProps.confirmButtonName}
                    </button>
                </div>
            </div>
        </div>
    ) : null

    return createPortal(component, portalElement)
}

ExpandTextDialog.propTypes = {
    show: PropTypes.bool,
    dialogProps: PropTypes.object,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func
}

export default ExpandTextDialog
